import React from 'react';

const InlineCode = ({ children }) => (
  <code className="inline bg-whisper text-cornflower p-1 rounded">
    {children}
  </code>
);

export default InlineCode;
